<script>
export default {
    name: 'SearchForm',

    functional: true,

    props: {
        search: {type: String, default: null},
        searchAction: {type: String, required: true},
        clearAction: {type: String, required: true},
        placeholder: {type: String, required: true},
    },
};
</script>

<template functional>
    <form
        class="form-inline"
        :class="[data.staticClass, data.class]"
        v-bind="data.attrs"
        :action="props.searchAction"
        v-on="listeners">
        <div class="input-group input-group-sm">
            <input
                :placeholder="props.placeholder"
                :value="props.search"
                type="text"
                name="search"
                class="form-control"
                autofocus
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false">

            <div class="input-group-append">
                <button type="submit" class="btn btn-secondary" :title="parent.$t('common.labels.search.submit')">
                    <i class="fa fa-fw fa-search" />
                    <span class="sr-only">
                        {{ parent.$t('common.labels.search.submit') }}
                    </span>
                </button>
            </div>

            <div v-if="props.search" class="input-group-append">
                <a class="btn btn-danger" :href="props.clearAction">
                    {{ parent.$t('common.labels.search.clear') }}
                </a>
            </div>
        </div>
    </form>
</template>
